//const newLineRegex = /(\r\n|\r|\n)/g;
const newLineRegex = /(\n)/g;

export const nl2br = (text) => {
    if (text) {
      const html = text.replace(newLineRegex,'<br/>');
      /*
          text.split(newLineRegex)
            .reduce((accumulator, currentValue, currentIndex, array) => {
              return accumulator + "+++" + currentValue;
            });
      */          
      return html;  
    } else {
      return '';
    }
}

export const replacedoamin = (text) => {
  if(text) {
    const html = text.replace("%s", process.env["REACT_APP_SFC_DOMAIN"]);
console.log(html);
    return html;
  }
  else{
    return '';
  }
}

export const getBaseName = () => {

  const SFCSC = process.env['REACT_APP_SFCSC_DOMAIN'];

  let basename;
  if (window.location.hostname === SFCSC) {
    basename = `/TuniS/${process.env['REACT_APP_APPS_DOMAIN']}${process.env['PUBLIC_URL']}`;
  } else {
    basename = process.env['PUBLIC_URL'];
  }
  return basename;  
}

export const getSfcBaseName = () => {

  const SFCSC = process.env['REACT_APP_SFCSC_DOMAIN'];

  let basename;
  if (window.location.hostname === SFCSC) {
    basename = `/TuniS/${process.env['REACT_APP_SFC_DOMAIN']}`;
  } else {
    basename = process.env['REACT_APP_SFC_DOMAIN'];
  }
  return basename;  
 
}